import { EndpointsOptionsMap } from '../system';
import * as portfolioApi from './portfolio';
import * as projectsApi from './projects';

export type ExperienceApiEndpointTypes = EndpointsOptionsMap<
  typeof projectsApi
>;
export { portfolioApi, projectsApi };
